import { useCallback } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { GET_EMBEDDED_ORIGINS, SET_EMBEDDED_ORIGINS } from "graphql/platform";

interface EmbeddedOriginsData {
  myPlatform?: { id: string; embeddedOrigins: string[] } | null;
}

/** The origins allowed to frame the platform's embedded components; every save replaces the whole list. */
export const useEmbeddedOrigins = ({ skip = false } = {}) => {
  const { data, loading, error } = useQuery<EmbeddedOriginsData>(
    GET_EMBEDDED_ORIGINS,
    { skip, fetchPolicy: "cache-and-network" },
  );
  const [setEmbeddedOrigins, { loading: saving }] = useMutation<{
    setEmbeddedOrigins: string[];
  }>(SET_EMBEDDED_ORIGINS, { refetchQueries: [GET_EMBEDDED_ORIGINS] });

  const saveOrigins = useCallback(
    async (origins: string[]) => {
      await setEmbeddedOrigins({ variables: { origins } });
    },
    [setEmbeddedOrigins],
  );

  return {
    origins: data?.myPlatform?.embeddedOrigins ?? [],
    loading: loading && !data,
    error,
    saving,
    saveOrigins,
  };
};

export default useEmbeddedOrigins;
